import React from 'react';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import KeyIcon from '@mui/icons-material/Key';
import { Option } from '@components/SideBar/interfaces';

export const rolesAndPermissionsMenuOptions: Option[] = [
  {
    key: 'roles',
    link: '/manage/roles-and-permissions/roles',
    icon: <AdminPanelSettingsIcon />,
    inProduction: true,
  },
  {
    key: 'permissions',
    link: '/manage/roles-and-permissions/permissions',
    icon: <KeyIcon />,
  },
];
